const Booking = {

    // FIELDS
    "booking": "Booking Request",
    "book_slot": "Book Slot",
    "booking_type": "Booking Type",
    "guest_count": "Guest Count",
    "description": "Description",
    "public": "Public",
    "private": "Private",
    "resource_name": "Resource Name",
    "resource": "Resource",
    "premise": "Premise",
    "date": "Date",
    "time_slot": "Time Slot",
    "booking_count": "Booking Count",
    "status": "Status",
    "search": "Search",
    "requested_by": "Requested By",

    // STATUS
    "status_pending": "Pending",
    "status_approved": "Approved",
    "status_rejected": "Rejected",
    "status_cancelled": "Cancelled",

    // SUCCESS
    "success_slot_booking": "Slot Booking Request Submitted Successfully.",
    "status_updated": "Booking Status Updated Successfully",

    // STATUS UPDATE
    "update_status_title": "Update Status",
    "update_status_text": "Select a new status for this booking",

    // DETAILS
    "details_title": "Booking Details",
    "details_not_found": "Booking details not available",
    "deposit": "Deposit",
    "created_at": "Created At",

    // ERROR
    "error_booking_type": "Select Booking Type",
    "error_guest_count": "Enter Guest Count",
    "error_min": "Value must be at least 1",
    "error_description": "Enter Description",
    "error_status_required": "Select Status",

    // TABLE HEADER
    "table_booking_id": "BOOKING ID",
    "table_resource": "AMENITIES",
    "table_premise": "PREMISE",
    "table_booking_date": "BOOKING DATE",
    "table_slot_timing": "SLOT TIMING",
    "table_booking_type": "BOOKING TYPE",
    "table_guest_count": "GUEST COUNT",
    "table_description": "DESCRIPTION",
    "table_requested_by": "REQUESTED BY",
    "table_status": "STATUS",

}

export default Booking;